import * as React from 'react';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { HomeIcon } from 'naan/icons/home-icon';
import { FavoriteFilledIcon } from 'naan/icons/favorite-filled-icon';
import { AvatarIcon } from 'naan/icons/avatar-icon';
import { EduIcon } from 'naan/icons/edu-icon';
import {
  ExternalItemWrapper,
  LinkNavItem,
  NavArrow,
  NavBottomAnchor,
  NavContainer,
  NavItem,
  NavLogoWrapper,
  PopoverNavHeader,
  PopoverNavTrigger,
} from 'components/ui/navigation/responsive-navigation';
import { LupaLogo } from 'components/ui/lupa-logo';
import { MenuContent } from 'naan/primitives/menus/menu-content';
import { MenuItem } from 'naan/primitives/menus';
import { SignOutIcon } from 'naan/icons/sign-out-icon';
import {
  ArrowTopRightExtraSmallIcon,
  ArrowTopRightIcon,
} from 'naan/icons/arrow-top-right-icon';
import { Text } from 'naan/primitives/text';
import { useNavigate } from 'react-router-dom';
import { Button } from 'naan/primitives/button';
import { Responsive } from 'naan/primitives/responsive';
import { Box } from 'naan/primitives/box';
import {
  classroomsPath,
  discoverPath,
  favoritesPath,
  learnHomePath,
} from './path-helpers';
import { SharedMenuItems } from './learn-navigation';

import __ from 'core/lib/localization';
import { AppFactory } from '@app/app-factory';

// type MenuItemProps = React.ComponentProps<typeof MenuItem>;

// const ExternalMenuItem = ({
//   label,
//   leftIcon,
//   action,
// }: Pick<MenuItemProps, 'label' | 'leftIcon' | 'action'>) => {
//   return (
//     <MenuItem
//       label={label}
//       leftIcon={leftIcon}
//       rightIcon={<ArrowTopRightIcon width={20} height={20} />}
//       presentation="navItem"
//       action={action}
//     />
//   );
// };

export const TeachMenuContent = () => {
  const { accountData } = AppFactory.root.userManager;

  const navigate = useNavigate();

  const goto = React.useCallback(
    (to: string) => () => {
      navigate(to);
    },
    [navigate]
  );

  // const open = React.useCallback(
  //   (to: string) => () => {
  //     openUrl(to);
  //   },
  //   []
  // );

  // const handleApplyCode = useCouponDialog();

  return (
    <MenuContent sideOffset={-20} css={{ minWidth: '300px', marginLeft: 8 }}>
      <PopoverNavHeader>
        <Text textStyle="small-heading">{accountData.name}</Text>
        <Text color="textSecondary" textStyle="small-text">
          {accountData.email}
        </Text>
      </PopoverNavHeader>
      <MenuItem
        label={'Manage my account'}
        leftIcon={<AvatarIcon />}
        presentation="navItem"
        action={goto('/app/profile/account')}
      />
      <SharedMenuItems />

      {/* // todo: refactor to handle native wrapper logout here also */}
      <MenuItem
        label={'Sign out'}
        leftIcon={<SignOutIcon />}
        presentation="navItem"
        separatorAfter={false}
        action={() => navigate('/logout')}
      />
      <Responsive
        renderDefault={() => (
          <Box css={{ padding: 16 }}>
            <Button
              label={__('Go to my Lupa', 'common.goToMyLupa')}
              onClick={() => navigate(learnHomePath())}
              rightIcon={<ArrowTopRightIcon width={20} height={20} />}
              presentation="grayLight"
              size={'small'}
            />
          </Box>
        )}
        renderLargeAndUp={() => null}
      />
      <DropdownMenu.Arrow offset={16} asChild>
        <NavArrow />
      </DropdownMenu.Arrow>
    </MenuContent>
  );
};

export const TeachNavigation = () => {
  const { accountData } = AppFactory.root.userManager;
  const navigate = useNavigate();

  return (
    <NavContainer presentation={'classroom'}>
      <NavLogoWrapper>
        <LupaLogo classrooms />
      </NavLogoWrapper>
      <Responsive
        renderLargeAndUp={() => (
          <ExternalItemWrapper>
            <Button
              label={__('Go to my Lupa', 'common.goToMyLupa')}
              onClick={() => navigate(learnHomePath())}
              rightIcon={<ArrowTopRightExtraSmallIcon />}
              size={'small'}
            />
          </ExternalItemWrapper>
        )}
      />
      <LinkNavItem
        to={discoverPath()}
        // beforeNavigate={clearSavedScrollPosition}
        icon={<HomeIcon />}
        label={'Discover'}
      />
      <LinkNavItem
        to={favoritesPath()}
        // beforeNavigate={clearSavedScrollPosition}
        icon={<FavoriteFilledIcon />}
        label={'Favorites'}
      />
      <LinkNavItem
        to={classroomsPath()}
        // beforeNavigate={clearSavedScrollPosition}
        icon={<EduIcon />}
        label={'My classes'}
      />
      <NavBottomAnchor>
        <DropdownMenu.Root>
          <PopoverNavTrigger>
            <NavItem
              icon={<AvatarIcon />}
              label={
                <>
                  <Box
                    css={{ display: 'none', '@large': { display: 'block' } }}
                  >
                    {accountData.name}
                  </Box>
                  <Box css={{ '@large': { display: 'none' } }}>
                    {__('Me', 'nav.me')}
                  </Box>
                </>
              }
            />
          </PopoverNavTrigger>
          <TeachMenuContent />
        </DropdownMenu.Root>
      </NavBottomAnchor>
    </NavContainer>
  );
};
